module.exports = __webpack_public_path__ + "img/12.a09bb749.jpg";